/**
 * DONNA Size Button Picker — donna-size-picker.js
 * Theme: Avone 5.6.0 | Store: donna.ro
 * Dependencies: None (vanilla JS)
 */
(function () {
  'use strict';

  var SIZE_OPTION_NAMES = [
    'Mărime', 'Marime', 'Mărimea', 'Size', 'Taille', 'Taglia', 'Größe', 'Maat'
  ];

  var productData = window.donnaProductData || {};
  var sizeStyle   = productData.sizeStyle || 'buttons';
  var sizeGuide   = productData.sizeGuide || null;

  function isSelectForSize(select) {
    var name = select.getAttribute('name') || '';
    return SIZE_OPTION_NAMES.some(function (n) {
      return name === 'options[' + n + ']';
    });
  }

  var _modal = null;

  function getOrCreateModal() {
    if (_modal) return _modal;
    _modal = document.createElement('div');
    _modal.className = 'donna-size-modal-overlay';
    _modal.setAttribute('role', 'dialog');
    _modal.setAttribute('aria-modal', 'true');
    _modal.setAttribute('aria-label', 'Ghid mărimi');
    _modal.innerHTML =
      '<div class="donna-size-modal">' +
        '<button type="button" class="donna-size-modal__close" aria-label="Închidem">&#x2715;</button>' +
        '<h2 class="donna-size-modal__title">Ghid mărimi</h2>' +
        '<div class="donna-size-modal__content"></div>' +
      '</div>';
    _modal.querySelector('.donna-size-modal__content').innerHTML = sizeGuide || '';
    _modal.querySelector('.donna-size-modal__close').addEventListener('click', closeModal);
    _modal.addEventListener('click', function (e) {
      if (e.target === _modal) closeModal();
    });
    document.body.appendChild(_modal);
    return _modal;
  }

  function openModal() {
    var m = getOrCreateModal();
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (_modal) {
      _modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function SizePicker(select) {
    this.select      = select;
    this.buttonsWrap = null;
    this.group       = null;
    this.observer    = null;
    this._init();
  }

  SizePicker.prototype._init = function () {
    var self   = this;
    var select = this.select;
    var parent = select.parentNode;

    if (sizeGuide) {
      var headerEl = parent.querySelector('.header') || select.previousElementSibling;
      if (headerEl) {
        var trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'donna-size-guide-trigger';
        trigger.textContent = 'Ghid mărimi';
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });
        headerEl.appendChild(trigger);
      }
    }

    this.buttonsWrap = document.createElement('div');
    this.buttonsWrap.className = 'donna-size-buttons-wrap';
    this.group = document.createElement('div');
    this.group.className = 'donna-size-buttons';
    this.group.setAttribute('role', 'group');
    this.group.setAttribute('aria-label', 'Selectează mărimea');
    this.buttonsWrap.appendChild(this.group);
    parent.insertBefore(this.buttonsWrap, select);

    select.classList.add('donna-select-hidden');
    select.setAttribute('aria-hidden', 'true');
    select.setAttribute('tabindex', '-1');

    this._renderButtons();

    this.observer = new MutationObserver(function () {
      self._syncAvailability();
      self._syncSelected();
    });
    this.observer.observe(select, {
      subtree: true, attributes: true, attributeFilter: ['class', 'selected']
    });
  };

  SizePicker.prototype._renderButtons = function () {
    var self         = this;
    var currentValue = this.select.value;
    this.group.innerHTML = '';
    Array.from(this.select.options).forEach(function (opt) {
      var isDisabled = opt.classList.contains('disabled');
      var isSelected = (opt.value === currentValue);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'donna-size-btn' +
        (isSelected ? ' donna-size-btn--selected' : '') +
        (isDisabled  ? ' donna-size-btn--disabled'  : '');
      btn.dataset.value = opt.value;
      btn.textContent   = opt.value;
      btn.setAttribute('aria-label', opt.value + (isDisabled ? ' — Indisponibil' : ''));
      if (isDisabled) btn.setAttribute('aria-disabled', 'true');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (btn.classList.contains('donna-size-btn--disabled')) return;
        self.select.value = opt.value;
        self.select.dispatchEvent(new Event('change', { bubbles: true }));
        self._syncSelected();
      });
      self.group.appendChild(btn);
    });
  };

  SizePicker.prototype._syncSelected = function () {
    var currentValue = this.select.value;
    this.group.querySelectorAll('.donna-size-btn').forEach(function (btn) {
      btn.classList.toggle('donna-size-btn--selected', btn.dataset.value === currentValue);
    });
  };

  SizePicker.prototype._syncAvailability = function () {
    var self = this;
    this.group.querySelectorAll('.donna-size-btn').forEach(function (btn) {
      var opt = Array.from(self.select.options).find(function (o) { return o.value === btn.dataset.value; });
      if (!opt) return;
      var isDisabled = opt.classList.contains('disabled');
      btn.classList.toggle('donna-size-btn--disabled', isDisabled);
      btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.dataset.value + (isDisabled ? ' — Indisponibil' : ''));
    });
  };

  function initAll() {
    if (sizeStyle !== 'buttons') return;
    document.querySelectorAll('variant-selects .single-option-selector').forEach(function (select) {
      if (select.dataset.donnainit) return;
      if (!isSelectForSize(select)) return;
      select.dataset.donnainit = '1';
      new SizePicker(select);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () { initAll(); });

})();

// Back-in-stock visibility patch (added 2026-05-23)
(function() {
  function updateBackInStock(btn) {
    var bis = document.getElementById('backInStock');
    if (!bis) return;
    if (btn && btn.classList.contains('donna-size-btn--disabled')) {
      bis.classList.remove('hide');
    } else {
      bis.classList.add('hide');
    }
  }
  document.addEventListener('click', function(e) {
    var btn = e.target.closest ? e.target.closest('.donna-size-btn') : null;
    if (btn) updateBackInStock(btn);
  }, true);
})();
